<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <Header
        pageTitle="Manage Finance Offices"
        class="card-container"
      ></Header>
      <div class="col-md-12">
        <div style="margin-left: 3px;" class="row">
          <export-group  :name="'Finance Offices'" :excelUrl="`api/financialoffices/excel`" :getData="filterExport"></export-group>
          <div class="col-md-5 col-sm-6 col-xs-6 align-right">
          
             <create-office @on-close="()=> this.getFinanceOfficesFromBackend()">
              <template  v-slot:modal-link>
                <span class="btn btn-secondary more-margin-top">
                                               <i style="height: 18px" class="tim-icons icon-simple-add"></i> Create New Finance
                Office
              </span>
              </template>
            </create-office>
          </div>

          <div class="col-md-3">
            <label for="searchBox">Search:</label>
            <el-input
              id="searchBox"
              type="search"
              class="mb-3 search-input"
              clearable
              prefix-icon="el-icon-search"
              placeholder="Search all Finance Offices..."
              v-model="searchText"
              v-b-popover.hover.bottom="
                'Search results appear immediately upon typing.'
              "
            ></el-input>
          </div>
        </div>
      </div>
      <div style="margin-top: 20px !important; margin-left: 19px !important;"  class="row">
        <div class="col-md-3">
          <label for="filterByCountry">Filter by Country:</label>
          <v-select
            id="filterByCountry"
            v-model="selectedCountry"
            name="CountiresDropdown"
            :reduce="(item) => item.countryId"
            label="name"
            :options="allCountiresOptions"
            placeholder="Select"
            v-b-popover.hover.left="
              'If a country filter is not selected, search results will pull for all countries.'
            "
          ></v-select>
        </div>
      </div>

      <div style="margin-right: 20px !important; margin-left: 20px !important;" class="row">
        <el-table :data="paginatedFinanceOffices.results" role="table"
        aria-label="Admin Finance Offices Table">
          <el-table-column :min-width="250" align="left" label="Actions">
            <div slot-scope="props">
              <office-edit :id="props.row.financialOfficeId">
              <template  v-slot:modal-link>
                <span class="btn-link btn-primary">
                                               <i class="tim-icons icon-pencil"></i> <span class="hide-if-small-screensize">Edit</span>
              </span>
              </template>
            </office-edit>

              <span class="hide-if-medium-screensize">|</span>

              <a
                href="##"
                @click="
                  deleteFinanceOffice(
                    props.row.financialOfficeId,
                    props.row.name
                  )
                "
                class="btn-link btn-danger"
              >
                <i class="tim-icons icon-trash-simple"></i>
                <span class="hide-if-small-screensize">Delete</span>
              </a>
            </div>
          </el-table-column>
          <el-table-column :min-width="180" align="left" label="Country Name">
            <div slot-scope="props">
             {{ allCountiresOptions.find(e => e.id == props.row.countryId ).name  }}
             </div>
          </el-table-column>
          <el-table-column
            v-for="column in tableColumns"
            sortable
            :key="column.label"
            :min-width="column.minWidth"
            :prop="column.prop"
            :label="column.label"
          ></el-table-column>
        </el-table>
      </div>
      <div class="row justify-content-end">
        <label for="ResultsPerPageDropdown" class="results-per-page"
          >Results Per Page:</label
        >
        <el-select
          id="ResultsPerPageDropdown"
          v-model="selectedResultsPerPage"
          readonly="false"
          name="PageOptions"
          class="select-primary"
        >
          <el-option
            v-for="(item, index) in getResultsPerPageOptions"
            :value="item"
            class="select-primary"
            :key="index"
          ></el-option>
        </el-select>

        <base-pagination
          :perPage="getTotalNumberOfPages"
          v-model="selectedPage"
          :pageCount="getTotalNumberOfPages"
        />
      </div>
    </div>
  </center>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BasePagination, ExportGroup } from "@/components";
import { Option, Select } from "element-ui";
import { Table, TableColumn } from "element-ui";
import axios from "@/axios";
import swal from "sweetalert2";import Util from "@/util/util";
import Header from "@/components/App/Header";
import OfficeEdit from "@/components/App/office/OfficeEdit.vue";
import CreateOffice from "@/components/App/office/CreateOffice.vue";


export default {
  name: "AdminFinanceOfficesDashboard",
  components: {
    Header,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Option.name]: Option,
    [Select.name]: Select,
    BasePagination,
    ExportGroup,
    OfficeEdit,
    CreateOffice
  },
  data() {
    return {
      selectedCountry: "",
      map: {          
          "Name": "name",
          "Email": "email",
          "DsnPhoneNumber": "dsnPhoneNumber",
          "CommercialPhoneNumber": "commercialPhoneNumber",                 
          "Address": "address",  
          "Country": "countryName"
      },
      tableColumns: [
        
        {
          prop: "name",
          label: "Office Name",
          minWidth: 175,
          scope: "col"
        },
        {
          prop: "email",
          label: "Office Email",
          minWidth: 150,
          scope: "col"
        },
        {
          prop: "address",
          label: "Office Address",
          minWidth: 180,
          scope: "col"
        },
        {
          prop: "dsnPhoneNumber",
          label: "DSN Phone #",
          minWidth: 180,
          scope: "col"
        },
        {
          prop: "commercialPhoneNumber",
          label: "Commercial Phone #",
          minWidth: 230,
          scope: "col"
        },
      ],
      searchText: "",
      searchTimeOut: null,
      selectedResultsPerPage: 5,
      selectedPage: 1,
      exportToExcelFlag: false,
      pagination: {},
    };
  },
  watch: {
    searchText() {
      clearTimeout(this.searchTimeOut);

      var self = this;
      self.searchTimeOut = setTimeout(function () {
        self.pageNumber = 1;
        self.getFinanceOfficesFromBackend();
      }, 1000);
    },
    selectedCountry() {
      this.pageNumber = 1;
      this.getFinanceOfficesFromBackend();
    },
    selectedResultsPerPage() {
      this.getFinanceOfficesFromBackend();
    },
    selectedPage() {
      this.getFinanceOfficesFromBackend();
    },
  },
  async created() {
    this.$loaderApp.addRequest();
    await this.getAllCountries();
    await this.getFinanceOfficesFromBackend();
    this.$loaderApp.completeRequest();
  },
  computed: {
    ...mapGetters({
      allCountiresOptions: "countries/allCountries",
      allFinanceOffices: "financeOffice/allFinanceOffices",
      paginatedFinanceOffices: "financeOffice/paginatedFinanceOffices",
    }),
    getResultsPerPageOptions() {
      return Util.getInitialPaginationInfo().perPageOptions;
    },
    getTotalNumberOfPages() {
      return Util.isNullOrEmpty(this.paginatedFinanceOffices)
        ? 1
        : this.paginatedFinanceOffices.pageCount;
    },
  },
  methods: {
    ...mapActions({
      getAllCountries: "countries/getAllCountries",
      getAllFinanceOffices: "financeOffice/getAllFinanceOffices",
      getPaginatedFinanceOffices: "financeOffice/getPaginatedFinanceOffices",
    }),
    async filterExport() {
      await this.getAllFinanceOffices({
        searchText: this.searchText,
        countryId: this.selectedCountry
      })

      return Util.mapTheData(this.allFinanceOffices, this.map);
    },

    async getFinanceOfficesFromBackend() {
      let apiInfo = {
        pageNumber: this.selectedPage,
        resultsPerPage: this.selectedResultsPerPage,
        searchText: this.searchText,
      };
      apiInfo.countryId = this.selectedCountry;
      await this.getPaginatedFinanceOffices(apiInfo);
    },
    deleteFinanceOffice(financeOfficeId, financeOfficeName) {
      new swal({
        title: "Delete Confirmation",
        text: `Do you want to delete: "${financeOfficeName}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#10b45a",
        cancelButtonColor: "red",
        confirmButtonText: `Delete Finance Office #${financeOfficeId}!`,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          axios
            .delete(`api/financialoffices/${financeOfficeId}`)
            .then((response) => {
              new swal({
                title: "Confirmation of Delete",
                text: `"${financeOfficeName}" has been deleted successfully.`,
                icon: "success",
                confirmButtonColor: "#10b45a",
                reverseButtons: true
              });
              this.getFinanceOfficesFromBackend();
            });
        }
      });
    },
  },
};
</script>

<style scoped>
</style>
